export default __webpack_public_path__ + "static/media/lorgavens-hero-video.08c93295.mp4";